var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSimCard = function SvgIconSimCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.349 2.005a1 1 0 0 1 .608.288l5.25 5.25a1 1 0 0 1 .293.707v12A1.75 1.75 0 0 1 18.75 22H5.25a1.75 1.75 0 0 1-1.75-1.75V3.75c0-.464.185-.91.513-1.237l.128-.117A1.75 1.75 0 0 1 5.25 2h9zM5.5 20h13V8.664L13.836 4H5.5zm10.353-9.37a1 1 0 0 1 .897.995v6a1 1 0 0 1-1 1h-7.5a1 1 0 0 1-1-1v-6l.005-.102a1 1 0 0 1 .995-.898h7.5zM9.25 16.625H11v-1.25a1 1 0 1 1 2 0v1.25h1.75v-4h-5.5z"
  })));
};
export default SvgIconSimCard;